export default __webpack_public_path__ + "static/media/bg.3d077df9.jpeg";